import React, { Component } from 'react';
import Radium from 'radium';
import utils from '../utilities';
import WMIconMenu from '@workmarket/front-end-components/dist/WMIconMenu';
import PersonIcon from 'material-ui/svg-icons/social/person';
import WMMenuItem from '@workmarket/front-end-components/dist/WMMenuItem';
import WMIconButton from '@workmarket/front-end-components/dist/WMIconButton';
import WMDivider from '@workmarket/front-end-components/dist/WMDivider';
import $ from 'jquery';

class SocialUserAvatar extends Component {
	render() {

		const styles = {
			img: {
				position: "absolute",
				marginTop: "-17px",
				marginLeft: "-17px",
				width: "32px",
				height: "32px",
				border: "solid 0.5px #cecece"
			}
		};

		return (
			this.props.avatar ?
				<img style={styles.img}
				src={this.props.avatar}/> :
				<PersonIcon color="#ffffff" />
			);
	}
}

class SocialUserMenu extends Component {

	updatePersona(type) {
		let params = {
			seller: type === 'perform_work',
			buyer: type === 'create_work',
			dispatcher: type === 'dispatch_work'
		};
		$.ajax({
			url: `/profile-edit/persona-toggle/${type}`,
			type: 'post',
			data: params,
			beforeSend: (xhr) => {
				xhr.setRequestHeader('X-CSRF-TOKEN', utils.getCSRFToken());
			},
			success: () => {
				window.location = '/home';
			}
		});
	}

	render() {
		const styles = {
			menuItem: {fontFamily: 'Open Sans', color: '#646b6f'},
			menuItemActive: {fontFamily: 'Open Sans', color: '#F79626'}
		};

		return (
			<WMIconMenu
				iconButtonElement={
					<WMIconButton style={ { verticalAlign: 'middle' } }>
						<SocialUserAvatar avatar={this.props.user.smallAvatarUri || 0} />
					</WMIconButton>
				}
				anchorOrigin={{horizontal: 'right', vertical: 'top'}}
				targetOrigin={{horizontal: 'right', vertical: 'top'}} >
				<WMMenuItem
					disabled={true}
					primaryText={this.props.user.email || 'your@email.here'} />
				<WMDivider />
				{this.props.user.userMenu.map((item,index) => (
					item.divider ? <WMDivider key={ `divider-${index}` } /> : (
						item.personatype ? (
								item.personatype === 'perform_work' ?
								<div key={index} >
									<WMMenuItem
										onClick={this.updatePersona.bind(this, item.personatype)}
										primaryText={item.title }
										style={this.props.user.seller ? styles.menuItemActive : styles.menuItem} />
								</div>
								:
								item.personatype === 'create_work' ?
									<div key={index} >
										<WMMenuItem
											onClick={this.updatePersona.bind(this, item.personatype)}
											primaryText={item.title}
											style={this.props.user.buyer ? styles.menuItemActive : styles.menuItem} />
									</div>
									:
									<div key={index} >
										<WMMenuItem
											onClick={this.updatePersona.bind(this, item.personatype)}
											primaryText={item.title}
											style={this.props.user.dispatcher ? styles.menuItemActive : styles.menuItem} />
									</div>
							)
							:
							<WMMenuItem
								key={index}
								href={item.href}
								onClick={item.action}
								primaryText={item.title}
								style={styles.menuItem} />
						)
					)
				)}
			</WMIconMenu>
		);
	}
}

export default SocialUserMenu = Radium(SocialUserMenu);
